import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AppAuthProvider } from './AppAuthContext';
import AppLogin from './AppLogin';
import AppHome from './AppHome';
import { Toaster } from '../../components/ui/sonner';

const AppLayout = () => {
  return (
    <AppAuthProvider>
      <div className="app-container">
        <Routes>
          <Route path="login" element={<AppLogin />} />
          <Route path="" element={<AppHome />} />
          <Route path="*" element={<Navigate to="/app" replace />} />
        </Routes>
        <Toaster position="top-center" richColors />
      </div>
    </AppAuthProvider>
  );
};

export default AppLayout;
